module.exports = __webpack_public_path__ + "static/media/iboats.png.png.11f9a003.webp";